import React from "react";
import { object } from "prop-types";
import "./imagewithoutshare.m.css";
import { Link, ResponsiveImage } from "@quintype/components";
import { extractTextFromHtml } from "../../helper/utils";

function ImagewithCaptionWithoutShare({ element, story }) {
  return (
    <>
      <div styleName="wrapper">
        {(() => {
          const image = (
            <ResponsiveImage
              story={story}
              slug={decodeURIComponent(element["image-s3-key"])}
              metadata={element.metadata}
              widths={[400, 800, 1300]}
              sizes="(max-width: 1024px) 1vw, 100vw"
              imgParams={{ auto: ["format", "compress"], fit: "max", q: 70 }}
              alt={extractTextFromHtml(element?.title) || element["image-attribution"] || ""}
            />
          );
          return element?.hyperlink ? <Link href={element.hyperlink}>{image}</Link> : image;
        })()}
      </div>
      <div styleName="image-caption-wrapper">
        <span styleName="image-caption-text" dangerouslySetInnerHTML={{ __html: element.title }} />
        <span styleName="image-attribute" dangerouslySetInnerHTML={{ __html: element["image-attribution"] }} />
      </div>
    </>
  );
}

ImagewithCaptionWithoutShare.propTypes = {
  element: object,
  story: object
};

export default ImagewithCaptionWithoutShare;
